<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <!--<h3 class="md-title">{{ $route.name }}</h3>-->
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item>
              <select v-model="$i18n.locale" @change="switchSelect($event)">
                <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                  {{ lang }}
                </option>
              </select>
            </md-list-item>
            <md-list-item href="#/app/settings">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      langs: ['de', 'en'],
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    switchSelect(event) {
      localStorage.setItem('lang', event.target.value);
    }
  }
};
</script>

<style lang="css"></style>
